import { API_CALL_RESPONSE, type ApiService } from '@/consts/events';
import type { TrackFunction } from '@/hooks/useAnalytics';

// Lives here, not in events.ts, because the events lock test treats every
// exported string there as an event name.
export const API_CALL_STATUS_OK = 'ok';

// Single source of the success row; is_error must be explicitly false so a
// success can never be read as a failure by an `is_error !== false` filter.
export const trackApiResponse = (track: TrackFunction, service: ApiService, stepName: string) => {
  track({
    event: API_CALL_RESPONSE,
    properties: { service, status: API_CALL_STATUS_OK, step_name: stepName, is_error: false },
  });
};
